import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import AuthLayout from "../../components/Auth/AuthLayout";
import AuthPageHelmet from "../../components/Auth/AuthPageHelmet";
import ResetPasswordForm from "./componets/ResetPasswordForm";
import { useSelectorApp } from "../../lib/redux";
import { useTranslationApp } from "../../lib/i18next";
import {
  AUTH_PAGE_BRANDING_LOGO_ALT,
  AUTH_PAGE_DOCUMENT_TITLE_RESET_PASSWORD,
} from "../../i18n/keysTranslations";

const ResetPassword = () => {
  const { theme } = useSelectorApp((state) => state.ui);
  const { t } = useTranslationApp();

  return (
    <AuthLayout showFeatures={false} fitCardToContent>
      <AuthPageHelmet
        documentTitleKey={AUTH_PAGE_DOCUMENT_TITLE_RESET_PASSWORD}
        nameBusiness={theme.nameBusiness}
      />
      <Box
        sx={{
          width: "100%",
          maxWidth: 400,
          mx: "auto",
        }}
      >
        <Box sx={{ textAlign: "start" }}>
          <Avatar
            src={theme.logoLogin}
            alt={t(AUTH_PAGE_BRANDING_LOGO_ALT)}
            variant="square"
            sx={{
              width: "100px",
              height: "auto",
              maxHeight: "48px",
              ".MuiAvatar-img": {
                maxWidth: "112px",
                objectFit: "contain",
              },
            }}
          />
        </Box>
        <ResetPasswordForm />
      </Box>
    </AuthLayout>
  );
};

export default ResetPassword;
